import cx from "classnames";
import { DOMSerializer, Node as ProseMirrorNode, } from "prosemirror-model";
import React, { useEffect, useMemo, useRef } from "react";
import { isEmpty } from "lodash";
import { createFullPresetExtensions } from "../../presets/full-preset";
import { generateSchema } from "../../core/extension";
import { isDocEmpty } from "../../core/empty";
/**
 * Serializes the given editor `doc` as HTML.
 */
export const EditorSerializer = ({ doc, className, extensions, }) => {
    const wrapper = useRef();
    const defaultExtensions = useMemo(() => {
        return createFullPresetExtensions();
    }, []);
    const schema = useMemo(() => generateSchema(extensions || defaultExtensions), [extensions, defaultExtensions]);
    const serializer = useMemo(() => DOMSerializer.fromSchema(schema), [schema]);
    useEffect(() => {
        if (isEmpty(doc) && isDocEmpty(doc)) {
            return;
        }
        const node = ProseMirrorNode.fromJSON(schema, doc);
        const fragment = serializer.serializeFragment(node);
        wrapper.current.innerHTML = "";
        wrapper.current.appendChild(fragment);
    }, [doc, schema, serializer]);
    return (React.createElement("div", { ref: wrapper, className: cx("ProseMirror ProseMirror--display", className) }));
};
